import React from 'react'


const CircleRemove = (props) =>

    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 455.992 455.992">
        <path d="M227.996 0C102.081 0 0 102.081 0 227.996c0 125.945 102.081 227.996 227.996 227.996 125.945 0 227.996-102.051 227.996-227.996C455.992 102.081 353.941 0 227.996 0zm0 425.593c-108.952 0-197.597-88.645-197.597-197.597S119.044 30.399 227.996 30.399s197.597 88.645 197.597 197.597-88.645 197.597-197.597 197.597z"/><path d="M312.142 122.358l-83.538 83.568-74.965-83.568c-5.928-5.928-15.565-5.928-21.492 0-5.928 5.928-5.928 15.565 0 21.492l74.965 83.568-84.723 84.723c-5.928 5.928-5.928 15.595 0 21.492 5.928 5.928 15.565 5.928 21.492 0l83.568-83.538 74.965 83.538c5.897 5.928 15.565 5.928 21.462 0 5.928-5.898 5.928-15.565 0-21.492l-74.995-83.538 84.723-84.754c5.928-5.928 5.928-15.565 0-21.492-5.928-5.927-15.534-5.927-21.462.001z"/>
    </svg>


export default CircleRemove


// WEBPACK FOOTER //
// ./src/components/_common/_icons/CircleRemove.js